module.exports = __webpack_public_path__ + "img/preppi.91968720.png";